import HttpClient from 'flow-doctor-lib/constants/HttpClient';
import { registerQuery } from 'data-fetching-client';
import { aggregatePagedApiResponse } from 'flow-doctor-lib/utils/apiUtils';
export const GET_FLOW = registerQuery({
  fieldName: 'fetchFlow',
  args: ['portalId', 'flowId'],
  fetcher({
    portalId,
    flowId
  }) {
    return HttpClient.get(`/automationplatform/v1/hybrid/${flowId}`, {
      query: {
        portalId
      }
    });
  }
});
export const GET_FLOW_CRM_OBJECTS_PAGED = registerQuery({
  fieldName: 'flowCrmObjectsPaged',
  args: ['portalId', 'query', 'objectType', 'sortColumn', 'sortDirection', 'offset', 'count'],
  fetcher({
    portalId,
    query,
    objectType,
    sortColumn,
    sortDirection,
    offset = 0,
    count = 10
  }) {
    const payload = {
      objectTypeId: '0-44',
      count,
      offset,
      filterGroups: [{
        filters: []
      }],
      requestOptions: {
        properties: ['hs_flow_id', 'hs_name', 'hs_object_type_id', 'hs_enrollment_trigger', 'hs_flow_created_at', 'hs_flow_updated_at']
      }
    };

    // If query is a number, try searching by flow ID
    if (query) {
      if (/^\d+$/.test(query)) {
        payload.filterGroups[0].filters.push({
          property: 'hs_flow_id',
          operator: 'EQ',
          value: query
        });
      } else {
        payload.query = query;
      }
    }
    if (objectType) {
      payload.filterGroups[0].filters.push({
        property: 'hs_object_type_id',
        operator: 'EQ',
        value: objectType
      });
    }
    if (sortDirection && sortDirection !== 'none') {
      payload.sorts = [{
        property: sortColumn,
        order: sortDirection === 'ascending' ? 'ASC' : 'DESC'
      }];
    }
    return HttpClient.post('crm-search/search', {
      query: {
        portalId
      },
      data: payload
    });
  }
});
export const GET_FLOW_LOG_EVENTS = registerQuery({
  fieldName: 'flowLogEvents',
  args: ['portalId', 'flowId', 'eventTypes', 'objectTypeId', 'objectId', 'limit', 'startTimestamp', 'endTimestamp', 'idempotencyId', 'enrollmentId'],
  fetcher({
    portalId,
    flowId,
    eventTypes,
    objectTypeId,
    objectId,
    startTimestamp,
    endTimestamp,
    idempotencyId,
    enrollmentId,
    limit = 99
  }) {
    const objectTypeParams = objectId ? {
      objectId,
      objectTypeId
    } : {};
    return HttpClient.get(`automationapps/v1/history/`, {
      query: Object.assign({
        eventTypes,
        flowId,
        portalId,
        limit,
        startTimestamp,
        endTimestamp,
        idempotencyId,
        enrollmentId
      }, objectTypeParams)
    });
  }
});
const requestFlowRevisions = ({
  flowId,
  portalId,
  nextCursor
}) => {
  return HttpClient.get(`automationplatform/v1/hybrid/revisions/${flowId}`, {
    query: {
      portalId,
      includeAssociatedBulkEnrollments: true,
      limit: 100,
      after: nextCursor
    }
  });
};
export const GET_FLOW_REVISIONS = registerQuery({
  fieldName: 'flowRevisions',
  args: ['portalId', 'flowId'],
  fetcher({
    portalId,
    flowId
  }) {
    return aggregatePagedApiResponse({
      request: requestFlowRevisions,
      baseArgs: {
        portalId,
        flowId
      },
      merger: (current, resp) => Object.assign({}, resp, {
        results: current.results.concat(resp.results)
      }),
      getNextCursor: resp => resp.paging && resp.paging.next.after
    });
  }
});
export const GET_REVISION_FOR_TIMESTAMP = registerQuery({
  fieldName: 'revisionForTimestamp',
  args: ['portalId', 'flowId', 'timestamp'],
  fetcher({
    portalId,
    flowId,
    timestamp
  }) {
    return HttpClient.get(`automationplatform/v1/hybrid/revisions/${flowId}/timestamp/${timestamp}`, {
      query: {
        limit: 1,
        portalId
      }
    });
  }
});
export const GET_ALL_CLASSIC_FLOWS = registerQuery({
  fieldName: 'alLClassicFlows',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get(`automation/v3/workflows`, {
      query: {
        portalId,
        property: ['id', 'name'],
        stats: false
      }
    });
  }
});